import { displayValue, formatDate } from './formatDate';

export const buildPrescriptionDetails = (prescription: any) => [
  {
    label: 'Medication Name',
    value: displayValue(prescription?.product?.name),
  },
  {
    label: 'Brand Name',
    value: displayValue(prescription?.product?.product_brand),
  },
  {
    label: 'Prescription Expiry',
    value: formatDate(prescription?.prescription_expiry),
  },
  {
    label: 'Prescribed Dose',
    value: displayValue(prescription?.prescribed_dosage),
  },
  {
    label: 'Prescribed by',
    value: prescription?.doctor
      ? `Dr. ${prescription.doctor.user?.first_name} ${prescription.doctor.user?.last_name}`
      : '-',
  },
  {
    label: 'Prescribed on',
    value: formatDate(prescription?.prescription_date),
  },
  {
    label: 'Medication Form:',
    value: displayValue(prescription?.medication_formrtacid),
  },
  {
    label: 'Medication Strength:',
    value: displayValue(prescription?.medication_strength),
  },
  {
    label: 'Route Admin:',
    value: displayValue(prescription?.route_administration),
  },
  {
    label: 'Interval Limit',
    value: `${prescription?.prescribed_interval?.toString() || '0'} days`,
  },
  {
    label: 'Repeats Remaining',
    value:
      prescription?.remaining_repeats !== undefined
        ? prescription.remaining_repeats <= 0
          ? 'Last Repeat'
          : prescription.remaining_repeats.toString()
        : '-',
  },
];
